export default __webpack_public_path__ + "static/media/logo-x-twitter.0a76695a.svg";